import {
  BasicIcon,
  HeaderType,
  Table,
  ToolTipPosition,
  Tooltip,
} from "@pickit/pickit-components";
import { PointStatusProps } from "./types";
import { useTranslation } from "react-i18next";
import { PointDetail } from "reducers/types/dashboard";
import { useCallback, useMemo } from "react";
import { DASHBOARD_TABLES_LIMIT, DATE_FORMATS, PENDING_ASSIGNMENT_STATES } from "utils/constants";
import moment from "moment";

const PointStatus = ({
  pointStatus,
  quantity,
  filters,
  currentPage,
  getPointStatus,
  countryCode,
}: PointStatusProps) => {
  const { t } = useTranslation("dashboard");

  const transactionUrlFilter = useMemo((): string => {
    const { shortISODate } = DATE_FORMATS;
    const today = moment().format(shortISODate);
    const filters = `minSla=${today}&maxSla=${today}`;
    return filters;
  }, []);

  const headers: HeaderType<PointDetail>[] = [
    {
      key: "address",
      label: t("address"),
      type: "button",
      buttonConfig: {
        hierarchy: "minimal",
        onClick: (row) => {
          window.open(`/${countryCode}/transaction?${transactionUrlFilter}&regions=${row.region.id}&workZones=${row.workZone.id}&origins=${row.id}&state=${PENDING_ASSIGNMENT_STATES}`);
        },
        valueLabel: true,
      },
      testId: 'address',
    },
    { key: "workZone.name", label: t("workZoneName"), col: 2, testId: 'workzone' },
    {
      key: "pending",
      label: t("pending"),
      col: 1,
      testId: 'pending',
    },
    {
      key: "assigned",
      label: t("assigned"),
      col: 1,
      testId: 'assigned',
    },
    { key: "idc", label: t("idc"), col: 1, testId: 'idc' },
  ];

  const handlePageChange = useCallback(
    (page: number) => {
      getPointStatus({
        ...filters,
        limit: DASHBOARD_TABLES_LIMIT,
        offset: page * DASHBOARD_TABLES_LIMIT,
      });
    },
    [filters, getPointStatus]
  );

  return (
    <>
      <div className="table-title-container">
        <h3 className="table-title" data-testid="point-status-title">{t("pointStatus")}</h3>
        <div className="tooltip-icon" data-testid="point-status-tooltip">
          <Tooltip
            message={t("pointStatusTooltip")}
            position={ToolTipPosition.right}
          >
            <BasicIcon
              name="information-circle"
              size="small"
              color="#0098ff"
            />
          </Tooltip>
        </div>
      </div>
      <Table<PointDetail>
        headers={headers}
        data={pointStatus}
        pagination="paginator"
        rowCount={10}
        cols={8}
        pages={{
          currentPage,
          totalPages: Math.ceil(quantity / DASHBOARD_TABLES_LIMIT),
        }}
        onChangePage={handlePageChange}
        noResultsText={t("noResults")}
        testId="point-status-table"
      />
    </>
  );
};

export default PointStatus;
